import { AppointmentItem, ScheduleRequest } from "../../domain";
import { CoreException, Either } from "../../../../sdk";

export abstract class AppointmentsRepository {
  abstract getAppointmentItems(id: number): Promise<Either<CoreException, AppointmentItem[]>>;
  abstract getSchedulesRequest(appointmentId: number): Promise<Either<CoreException, ScheduleRequest[]>>;
  abstract acceptScheduleRequest(scheduleId: number): Promise<Either<CoreException, ScheduleRequest[]>>;
}